<template>
    <div class="p-3">
        <h3>RL 1.1 Profil Rumah Sakit</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Profil" :filter-configs="filterConfigs" :table-options="tableOptions"
            :show-filter="false" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
            ],
            tableOptions: {
                baseUrl: '/api/identitas-rumah-sakit/profil-rumah-sakit',
                groupBy: 'section',
                groupHeader: function (value, count, data) {
                    return value.toUpperCase();
                },
                columns: [
                    {
                        title: 'Deskripsi',
                        field: 'description',
                    },
                    {
                        title: 'Nilai',
                        field: 'value',
                        widthGrow: 1,
                        editor: 'input', // Make editable if needed
                    },
                ],
                ajaxResponse: (url, params, response) =>response
            }
        }
    },
    methods: {
        openDetailPage(e, cell) {
            const data = cell.getRow().getData()
            const regno = data.Regno

            this.$router.push({
                name: 'konsul_antar_poli_detail',
                params: { Regno: regno }
            })
        },
    }
}
</script>
